module.exports = __webpack_public_path__ + "img/s3-2-ja.989952c0.jpg";